import { Button as SemanticButton } from 'semantic-ui-react';
import React from 'react';

const KickbackKindButton = ({
  kind = 'percentage',
  handleChange,
  disabled = false
}) => {
  const buttonStyle = {
    height: '36px',
    borderRadius: '8px',
    cursor: 'pointer'
  };

  const percentageButtonStyle = {
    ...buttonStyle,
    backgroundColor: kind === 'percentage' ? '#FFFFFF' : '#EBEBEB'
  };

  const amountButtonStyle = {
    ...buttonStyle,
    backgroundColor: kind === 'amount' ? '#FFFFFF' : '#EBEBEB'
  };

  return (
    <SemanticButton.Group className="flex items-center bg-[#EBEBEB] rounded-lg p-1">
      <SemanticButton
        type="button"
        style={percentageButtonStyle}
        className="px-6"
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          handleChange('percentage');
        }}
        positive={kind === 'percentage'}
      >
        <div className="text-[14px] text-[#202020]">%</div>
      </SemanticButton>
      <SemanticButton
        style={amountButtonStyle}
        type="button"
        className="px-6"
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          handleChange('amount');
        }}
        positive={kind === 'amount'}
      >
        <div className="text-[14px] text-[#202020]">$</div>
      </SemanticButton>
    </SemanticButton.Group>
  );
};

export default KickbackKindButton;
